<mojo-viewbar></mojo-viewbar>
<mojo-page-title [showProductTitle]="true" title="System Settings"></mojo-page-title>

<section class="full-page-scrollable">
  <div class="panel resizable-page-widget">
    <div class="panel-body">
      <!-- accordion -->
      <p-accordion [multiple]="true">
        <p-accordionTab header="General Information">
          <mojo-mojo-general-information #section></mojo-mojo-general-information>
        </p-accordionTab>
        <p-accordionTab header="Activity Settings">
          <mojo-mojo-activity-settings #section></mojo-mojo-activity-settings>
        </p-accordionTab>
        <p-accordionTab header="Overview Configuration">
          <mojo-mojo-overview-configuration #section></mojo-mojo-overview-configuration>
        </p-accordionTab>
        <p-accordionTab header="Approval Group">
          <mojo-mojo-approval-group #section></mojo-mojo-approval-group>
        </p-accordionTab>
        <p-accordionTab header="Invoice Logging and Suggested Coding">
          <mojo-mojo-suggested-coding #section></mojo-mojo-suggested-coding>
        </p-accordionTab>
        <p-accordionTab header="Document Centre Settings">
          <mojo-mojo-document-centre-settings #section></mojo-mojo-document-centre-settings>
        </p-accordionTab>
        <p-accordionTab header="Call Subjects">
          <contact-us-subject #section></contact-us-subject>
        </p-accordionTab>
        <p-accordionTab header="FAQ Subjects">
          <faq-category #section></faq-category>
        </p-accordionTab>
        <p-accordionTab header="Lister Configuration">
          <mojo-lister-configuration #section></mojo-lister-configuration>
        </p-accordionTab>
        <p-accordionTab header="Email">
          <mojo-send-test-email #section></mojo-send-test-email>
        </p-accordionTab>
      </p-accordion>
      <!-- buttons (save/cancel etc..) -->
      <div class="button-bar ui-dialog-buttonpane ui-helper-clearfix text-center">
        <button id="save-button" type="button" (click)="submit()" label="Save" pButton
                [disabled]="!canSubmit()"></button>
        <button id="cancel-button" type="button" pButton (click)="resetForm()" label="Cancel"
                [disabled]="!canReset()"></button>
      </div>
    </div>
    </div>
  </section>

<p-confirmDialog appendTo="body" #cd>
  <p-footer>
    <button type="button" pButton icon="fa fa-check" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="fa fa-times" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

